// Persistent bottom-right banner listing write-throughs that failed (deploy
// restart, network drop, …). Names the exact record and change, and can
// re-send the original request — replaces the old blocking alert() that
// couldn't say WHAT hadn't saved.
import { AlertTriangle, RotateCw, X } from 'lucide-react'
import { useStore } from '@/store/useStore'

const time = (iso: string) =>
  new Date(iso).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })

export function FailedSavesBanner() {
  const failed = useStore((s) => s.failedSaves)
  const retry = useStore((s) => s.retryFailedSave)
  const dismiss = useStore((s) => s.dismissFailedSave)
  if (!failed.length) return null
  return (
    <div className="fsave" role="alert">
      <div className="fsave-head">
        <AlertTriangle size={15} />
        <b>{failed.length === 1 ? 'A change didn’t save' : `${failed.length} changes didn’t save`}</b>
        <span className="fsave-sub">Still shown on screen — retry to keep {failed.length === 1 ? 'it' : 'them'}.</span>
      </div>
      {failed.map((f) => (
        <div key={f.key} className="fsave-row">
          <span className="fsave-what">
            <b>{f.label}</b> — {f.detail} <span className="fsave-meta">({f.coll} · {time(f.at)})</span>
          </span>
          <button className="fsave-btn" title={`Retry — ${f.error}`} onClick={() => retry(f.key)}>
            <RotateCw size={13} /> Retry
          </button>
          <button className="fsave-btn fsave-btn--quiet" title="Discard — the change will be lost on refresh" onClick={() => dismiss(f.key)}>
            <X size={13} />
          </button>
        </div>
      ))}
    </div>
  )
}
